import React from 'react';

const ReviewForm = () => {
    return <div className="form-container">Review</div>;
}

export default ReviewForm;